var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7413 28.5244C5.48793 28.5244 1 27.7304 1 24.5486C1 21.3669 5.45932 18.4999 10.7413 18.4999C15.9946 18.4999 20.4811 21.3397 20.4811 24.52C20.4811 27.7004 16.0232 28.5244 10.7413 28.5244Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7412 13.9623C14.1891 13.9623 16.9846 11.1668 16.9846 7.71892C16.9846 4.27107 14.1891 1.47559 10.7412 1.47559C7.29337 1.47559 4.49785 4.27107 4.49785 7.71892C4.48502 11.1553 7.2619 13.9508 10.6969 13.9623H10.7412Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.103 12.2473C23.1102 11.7108 24.5895 9.88101 24.5895 7.70357C24.5909 5.4317 22.9786 3.53467 20.8354 3.09546",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0466 17.3615C24.8908 17.3615 27.32 19.29 27.32 21.011C27.32 22.0254 26.4831 23.0669 25.2098 23.3659",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.b17ed2839bd9bbf02c7fd4d0de6c39fd.svg";
export { ForwardRef as ReactComponent };